import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers/index';
import { Observable } from 'rxjs';
import { SEOService } from '@app/core/services/seo.service';
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit { // 
  hasToken$: Observable<boolean>;

  constructor(
    private router: Router,
    private readonly store$: Store<fromRoot.State>,
    private seoService: SEOService
  ) {
    this.hasToken$ = this.store$.select(fromRoot.getHasToken);
  }

  ngOnInit() {
    // Seo
    this.seoService.removeHreflang();
  }

  onSmash() {
    this.router.navigateByUrl('/');
  }

}
